export enum EnvType {
	DEV = 'dev',
	QA = 'qa',
	UAT = 'uat',
	PROD = 'prod'
}
